import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Close24 from '../../icons/Close24';

import styles from './alert.scss';

export default function Alert({ title, content, onClose }) {

    function handleCloseClick() {
        if (onClose) {
            onClose();
        }
    }

    return ReactDOM.createPortal(
        <div className={styles.wrapper}>
            <div className={styles.mainContent}>
                <h3>{title}</h3>
                <div className={styles.close} onClick={handleCloseClick}>
                    <Close24 />
                </div>
            </div>
            <div className={styles.additionalContent}>
                <p>{content}</p>
            </div>
        </div>,
        document.getElementById('popouts-portal')
    );
}

Alert.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string,
    onClose: PropTypes.func,
};
